import { apiClient } from './apiService';

export type OnePayPaymentMethod =
  | 'INTERCARD'
  | 'APPLEPAY'
  | 'SAMSUNGPAY'
  | 'GOOGLEPAY'
  | 'VIETQR'
  | 'VIETQRPAYGLOBAL'
  | 'VTBBANKQR';

export type OnePayPaymentLinkRequest = {
  paymentMethods?: OnePayPaymentMethod[];
};

export const paymentService = {
  getVNPayUrl(data: { id?: string; paymentType: string; bankCode?: string }) {
    return apiClient.request({
      method: 'POST',
      url: `/mobileCustomer/confirm_payment`,
      data,
    });
  },

  getVNPayUrlMobile(data: {
    id?: string;
    paymentType: string;
    bankCode?: string;
  }) {
    return apiClient.request({
      method: 'POST',
      url: `/mobileCustomer/confirm_payment_mobile`,
      data,
    });
  },

  paymentSuccess(data: { id?: string }) {
    return apiClient.request({
      method: 'POST',
      url: `mobileCustomer/success_payment`,
      data,
    });
  },

  paymentSuccessMobile(data: { id?: string }) {
    return apiClient.request({
      method: 'POST',
      url: `mobileCustomer/success_payment_mobile`,
      data,
    });
  },

  getMBBankUrl(id: string) {
    return apiClient.request({
      method: 'POST',
      url: `/orders/${id}/mb_payment_link`,
    });
  },

  getOnePayUrl(id: string, data?: OnePayPaymentLinkRequest) {
    return apiClient.request({
      method: 'POST',
      url: `/payments/${id}/onepay_payment_link`,
      data,
    });
  },
};
